
import { privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";

export default {
    name: "PortfolioKpiRealizedModal",

    mixins: [privacyModeTextFormatterMixin],

    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['input', 'success'],

    computed: {
        secondaryTotals() {
            return this.$store.state.preferences.kpiTotalData?.secondaryTotals || {};
        },
    },

    created() {
        this.format = new FormatterService();
    },

    methods: {
        openWindow() {
            this.$emit('input', true)
        },
        closeWindow() {
            this.$emit('input', false)
        },
        onKeyDown(e) {
            if (e.key === 'Escape') this.closeWindow();
            if (e.key === 'Enter' && this.isVisible) {
                this.closeWindow()
            }
        },
    },
}
